const state = {
    invoiceViewParam:{},
    invoiceData:[],
};

const getters = {
    getInvoiceViewParam:state => (state.invoiceViewParam),
    getInvoiceData:state => (state.invoiceData),
};

const actions = {
    fetchInvoiceViewParam({ commit }, obj){
        commit('setInvoiceViewParam', obj)
    },
    fetchInvoiceData({ commit }, obj){
        commit('setInvoiceData', obj)
    },
};

const mutations = {
    setInvoiceViewParam:(state, res) => (
      state.invoiceViewParam =  res
    ),
    setInvoiceData:(state, res) => (
        state.invoiceData =  res
      ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}